var _path, _path2, _path3, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasicBackgroundCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#13426B",
  fillRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0 0 5.373 0 12s5.37 12 11.995 12",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#13426B",
  fillRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0 0 5.373 0 12s5.37 12 11.995 12",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0 0 5.373 0 12s5.37 12 11.995 12",
  clipRule: "evenodd"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "b",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0 0 5.373 0 12s5.37 12 11.995 12",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#fff",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0 0 5.373 0 12s5.37 12 11.995 12Z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.394
}, /*#__PURE__*/React.createElement("mask", {
  id: "c",
  width: 25,
  height: 24,
  x: 6,
  y: 5,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m18.82 5.33 11.22 11.302-12.206 12.294L6.822 17.66c.257-6.158 11.997-12.33 11.997-12.33",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.07 19.21c5.062 0 9.165-4.134 9.165-9.232 0-5.1-4.103-9.232-9.165-9.232S1.905 4.879 1.905 9.978 6.01 19.21 11.07 19.21",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.37 5.117 12.145 4.07a1 1 0 0 0-.341 0L5.579 5.117c-.5.084-.867.52-.867 1.031v7.322c0 4.881 6.651 7.172 6.935 7.267a1.03 1.03 0 0 0 .655 0c.284-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("mask", {
  id: "d",
  width: 16,
  height: 17,
  x: 4,
  y: 4,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.37 5.117 12.145 4.07a1 1 0 0 0-.341 0L5.579 5.117c-.5.084-.867.52-.867 1.031v7.322c0 4.881 6.651 7.172 6.935 7.267a1.03 1.03 0 0 0 .655 0c.284-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E25829",
  fillRule: "evenodd",
  d: "M16.185 10.064a.57.57 0 0 0-.164-.4l-.797-.802a.567.567 0 0 0-.797 0l-3.844 3.87-1.723-1.737a.567.567 0 0 0-.797 0l-.797.8a.573.573 0 0 0 0 .802l2.121 2.132.797.802a.567.567 0 0 0 .797 0l.797-.802 4.243-4.265a.57.57 0 0 0 .164-.4",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.5
})))));
export default SvgBasicBackgroundCheck;